var $ = require("jquery");

var controllers = {
  "ajax-form": require("./ajax-form"),
  "reservit-form": require("./reservit-form"),
  "tab-group": require("./tab-group"),
  "hidden-section": require("./hidden-section"),
};

$.fn.initControllers = function () {
  this.find("[data-controller]").each(function () {
    var ctrl = $(this).data("controller");

    if (controllers[ctrl]) {
      new controllers[ctrl](this);
    }
  });
};

$(document).initControllers();



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/controllers/index.js
// module id = 245
// module chunks = 0